/* eslint-disable @typescript-eslint/unbound-method */
// © 2015-2021 WDNA - All Rights Reserved

import * as React from 'react';
import _ from 'lodash';

import { UserDO } from 'wdna-components/lib/types.new';
import { getErrorMessage } from 'wdna-components/lib/helpers/response';
import { messageError, messageInfo } from 'wdna-components/lib/helpers/notification';
import UiValidate from 'wdna-components/lib/forms/validation/UiValidate';

import { authorization } from '../requests';

interface State {
  name?: string;
  email?: string;

  passwordOld?: string;
  passwordNew?: string;
  passwordChk?: string;

  loading?: boolean;
}

export default class UserPassword extends React.Component<unknown, State> {
  private mounted: boolean;

  public constructor(props: unknown) {
    super(props);

    this.mounted = false;

    this.state = {
      // Login del usuario
      name: '',
      email: '',

      passwordOld: '',
      passwordNew: '',
      passwordChk: '',

      loading: false,
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);
  }

  public componentDidMount(): void {
    this.mounted = true;
    this.getData();
  }

  public componentWillUnmount(): void {
    this.mounted = false;
  }

  public setLocalState = (nextState: Partial<State>, callback?: (() => void)): void => {
    if (this.mounted) {
      this.setState((prevState: State) => ({
        ...prevState,
        ...nextState,
      }), callback);
    }
  };

  public getData(): void {
    this.loadingStart();
    authorization<UserDO>('myinfo')
      ?.then((user: UserDO) => {
        this.setLocalState({
          name: user.name || undefined,
          email: user.email || undefined,
        });
      })
      .catch((error: any) => {
        messageError('Error', getErrorMessage(error));
      })
      .finally(() => {
        this.loadingFinish();
      });
  }

  public chkPassword = (password: string): boolean => {
    const regex: RegExp = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,20}$/;
    if (regex.exec(password)) return true;

    messageError('Error', 'Password must be between 6 to 20 characters which contain at least one numeric digit, one uppercase and one lowercase letter');
    return false;
  };

  public handleFormSubmit(e: React.FormEvent<HTMLFormElement>): void {
    e.preventDefault();

    const { passwordOld, passwordNew, passwordChk } = this.state;
    if (passwordOld && passwordNew && passwordNew === passwordChk && this.chkPassword(passwordNew)) {
      const formData: URLSearchParams = new URLSearchParams();
      formData.append('pold', passwordOld);
      formData.append('pnew', passwordNew);

      this.loadingStart();
      authorization('password', formData)
        ?.then(() => {
          messageInfo('Success', 'Data saved successfully', 5000);
        })
        .catch((error: any) => {
          messageError('Error', getErrorMessage(error));
        })
        .finally(() => {
          this.loadingFinish();
        });
    } else {
      messageError('Error', 'Password Confirm incorrect!!');
    }
  }

  public handleChange(e: React.ChangeEvent<HTMLInputElement>): void {
    const { name, value } = e.target;
    this.setLocalState({ [name]: value });
  }

  public loadingStart(): void {
    this.setLocalState({ loading: true });
  }

  public loadingFinish(): void {
    this.setLocalState({ loading: false });
  }

  public render(): JSX.Element {
    const { loading, name, email, passwordOld, passwordNew, passwordChk } = this.state;

    return (
      <UiValidate>
        <form className="smart-form" onSubmit={this.handleFormSubmit}>
          <fieldset>
            <label className="label">User account</label>
            <section>
              <label className="input">
                <i className="icon-append fa fa-user" />
                <input
                  type="text"
                  value={_.defaultTo(name, '')}
                  onChange={this.handleChange}
                  name="name"
                  placeholder="User name"
                  disabled
                />
              </label>
            </section>
            <section>
              <label className="input">
                <i className="icon-append fa fa-envelope" />
                <input
                  type="email"
                  value={_.defaultTo(email, '')}
                  onChange={this.handleChange}
                  name="email"
                  placeholder="Email"
                  disabled
                />
              </label>
            </section>
            <section>
              <label className="input">
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  value={_.defaultTo(passwordOld, '')}
                  onChange={this.handleChange}
                  name="passwordOld"
                  placeholder="Old Password"
                  id="passwordOld"
                />
                <b className="tooltip tooltip-bottom-right">Old password</b>
              </label>
            </section>
            <section>
              <label className="input">
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  value={_.defaultTo(passwordNew, '')}
                  onChange={this.handleChange}
                  name="passwordNew"
                  placeholder="New Password"
                  id="passwordNew"
                />
                <b className="tooltip tooltip-bottom-right">New password</b>
              </label>
            </section>
            <section>
              <label className="input">
                <i className="icon-append fa fa-lock" />
                <input
                  type="password"
                  value={_.defaultTo(passwordChk, '')}
                  onChange={this.handleChange}
                  name="passwordChk"
                  placeholder="Confirm password"
                  id="passwordChk"
                />
                <b className="tooltip tooltip-bottom-right">Confirm password</b>
              </label>
            </section>
          </fieldset>
          <footer>
            <div className="text-right">
              {loading && <img className="loading-wdna" src="assets/img/loading-wdna.gif" alt="logo" />}

              <button type="submit" className="btn btn-primary">
                Save
              </button>
            </div>
          </footer>
        </form>
      </UiValidate>
    );
  }
}
